// extracted by mini-css-extract-plugin
export default {"Title":"Navbar_Title__DlC3k","button":"Navbar_button__ntxjW"};